// import React from "react";
// import ReactDOM from "react-dom";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { base_path } from "./environment";
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import "../src/index.scss";
// import store from "./core/data/redux/store";
// import { Provider } from "react-redux";
// import { ToastContainer } from "react-toastify";
// import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
// import GetBatchesVk from "./feature-module/GetBatchesVk";
// import GetBatches from "./feature-module/GetBatches";

// // Import your pages/components

// const App = () => (
//   <Provider store={store}>
//     <BrowserRouter basename={base_path}>
//       <Routes>
//         <Route path="/GetBatchesVk" element={<GetBatchesVk />} />
//         <Route path="/getBatches/:module" element={<GetBatches />} />
//       </Routes>
//       <ToastContainer />
//     </BrowserRouter>
//   </Provider>
// );

// ReactDOM.render(<App />, document.getElementById("root"));

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  //  <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter basename={base_path}>
      <ALLRoutes />
      <ToastContainer />
    </BrowserRouter>
  </Provider>,
  //</React.StrictMode>
);
